// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ShipFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ShipFilledIcon" ref={forwardedRef} {...props}>
      <path d="M9 2.5h2v2h1.312a1 1 0 0 1 .964.733L14.25 8.75l-3.777-2.027a1 1 0 0 0-.946 0L5.75 8.75l.974-3.517A1 1 0 0 1 7.688 4.5H9z" />
      <path d="m13.697 16.03 2.224-3.56a1 1 0 0 0-.396-1.422l-5.073-2.57a1 1 0 0 0-.904 0l-5.113 2.59a1 1 0 0 0-.418 1.386l2.007 3.539a1 1 0 0 0 .299.327L6.15 16.45a.25.25 0 0 1-.3 0l-.8-.6a1.75 1.75 0 0 0-2.1 0l-1.4 1.05a.75.75 0 0 0 .9 1.2l1.4-1.05a.25.25 0 0 1 .3 0l.8.6a1.75 1.75 0 0 0 2.1 0l.8-.6a.25.25 0 0 1 .3 0l.8.6a1.75 1.75 0 0 0 2.1 0l.8-.6a.25.25 0 0 1 .3 0l.8.6a1.75 1.75 0 0 0 2.1 0l.8-.6a.25.25 0 0 1 .3 0l1.4 1.05a.75.75 0 1 0 .9-1.2l-1.4-1.05a1.75 1.75 0 0 0-2.1 0l-.8.6a.25.25 0 0 1-.3 0l-.306-.23a1 1 0 0 0 .153-.19" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const ShipFilledIcon = /* @__PURE__ */ Object.assign(
  ShipFilledIconComponent,
  { displayName: 'ShipFilledIcon' },
);
